import { ApplicationStateKeys } from '../constants/Application';

/**
 * Is the app buffering API calls due to service unavail?
 *
 * @param {object} state - redux state
 * @returns {boolean} true/false
 */
export function isBufferingApiCalls(state) {
  return state.application.get(ApplicationStateKeys.IS_BUFFERING_API_CALLS);
}

export function getRoutedCount(state) {
  return state.application.get(ApplicationStateKeys.ROUTED_COUNT);
}

export function isInitialLoad(state) {
  return getRoutedCount(state) < 1;
}

export function getPreviousPath(state) {
  return state.application.get(ApplicationStateKeys.PREVIOUS_PATH);
}

export function isAdBlockerDetected(state) {
  return state.application.get(ApplicationStateKeys.IS_AD_BLOCKER_DETECTED);
}

export function isBrowserAutoPlayDetected(state) {
  return state.application.get(ApplicationStateKeys.IS_BROWSER_AUTOPLAY_BLOCK_DETECTED);
}

export function isAntiAdBlockerHammerModeDetected(state) {
  return state.application.get(ApplicationStateKeys.IS_ANTI_AD_BLOCKER_HAMMER_MODE_DETECTED);
}

export function isBrowserAutoPlayBlockOpportunityHappened(state) {
  return state.application.get(ApplicationStateKeys.IS_BROWSER_AUTOPLAY_BLOCK_OPPORTUNITY_HAPPENED);
}

export default {
  isBufferingApiCalls,
  getRoutedCount,
  isInitialLoad,
  getPreviousPath,
  isAdBlockerDetected,
  isBrowserAutoPlayDetected,
  isBrowserAutoPlayBlockOpportunityHappened,
};
